import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {Box, Typography, CircularProgress, Card, CardContent, Chip, Grid2} from '@mui/material';
import { RenderParticipantName } from './Elements';
import { fetchLatestEntries, Entry } from '../api/contests';
import StyledLink from "../utils/StyledLink";

const LatestEntries: React.FC = () => {
    const [entries, setEntries] = useState<Entry[]>([]);
    const [loading, setLoading] = useState(true);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    useEffect(() => {
        fetchLatestEntries(12)
            .then((data) => {
                setEntries(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching latest entries:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={3}>
                <CircularProgress />
            </Box>
        );
    }

    const toggleExpand = (index: number) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <Box p={3}>
            <Typography variant="h5" gutterBottom color="primary">
                Последние поступления
            </Typography>
            <Grid2 container spacing={3} columns={12} >
                {entries.map((entry, index) => (
                    <Grid2 size={{xs:12, sm:6, md:4}} key={index}>
                        <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                            <CardContent>
                                {/* Participant Name */}
                                <Box display="flex" alignItems="center" mb={1}>
                                    {RenderParticipantName(entry.participant_id, `${entry.name}`, entry.profile_picture, true)}
                                    <Chip
                                        label={new Date(entry.timestamp!).toLocaleDateString("ru")}
                                        size="small"
                                        sx={{ ml: 'auto', backgroundColor: '#e0f7fa', color: '#00796b' }}
                                    />
                                </Box>
                                {/* Contest Name and Grouping */}
                                <Typography variant="h6">
                                    <Link 
                                        to={`/contest/${entry.contest_id}?tab=1&group=${encodeURIComponent(entry.grouping)}`}
                                        style={{ textDecoration: 'none', color: '#1976d2' }}
                                    >
                                        {entry.contest_name || 'Неизвестно'}
                                    </Link>
                                    {entry.grouping && (
                                        <Typography variant="body2" color="textSecondary" display="inline" ml={1}>
                                            ({entry.grouping})
                                        </Typography>
                                    )}
                                </Typography>
                                {/* Expandable Participant Data */}
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    mt={1}
                                    sx={{
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: expandedIndex === index ? 'none' : 3,
                                    }}
                                >
                                    {entry.participant_data || 'Без комментариев'}
                                </Typography>
                                {entry.participant_data && entry.participant_data.length > 100 && (
                                    <Typography
                                        variant="body2"
                                        color="primary"
                                        sx={{ cursor: 'pointer', mt: 1 }}
                                        onClick={() => toggleExpand(index)}
                                    >
                                        {expandedIndex === index ? 'Свернуть' : 'Читать далее'}
                                    </Typography>
                                )}
                                {/* Evidence Link */}
                                {entry.evidence_url && (
                                    <Typography variant="body2" mt={1}>
                                        <StyledLink to={entry.evidence_url} external>
                                            Видео
                                        </StyledLink>
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>
        </Box>
    );
};

export default LatestEntries;
